import AutosuggestContractItem from './AutosuggestContractItem';

export default AutosuggestContractItem;
